// Universal Analytics (UA) tracking was removed. Analytics is handled via GTM/GA4 only.
// These no-ops remain so existing call sites do not need changes until events are migrated to GA4.

export const pageview = (_url) => {};

export const event = (_payload) => {};
